
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2023-02-24-turbo",
      function () {
        return require("private-next-pages/blogs/2023-02-24-turbo/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2023-02-24-turbo"])
      });
    }
  